import React from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import Header from "../../components/Header/Header";
import SideBar from "../../components/SideBar/AdminSideBar";
import {
  avatar01,
  blog6
} from "../../components/imagepath";
import { hooks } from "../../studentportal-sdk";
import CourseSidebar from "../../components/SideBar/CourseSidebar";
import {  Skeleton} from "antd"; 
import {  Col} from "react-bootstrap";

/* eslint-disable */

const CourseView = (props) => {
  const {
    courseService: {
      store: { courseDocs, loading },
      action:{storeCourseAction, deleteCourseById}
    },
  } = props;

  const role = localStorage.getItem('role')

  return (
    <div>
      <>
        <div className="main-wrapper">
          {/* Header */}
          <Header />
          {/* Sidebar */}
          {role==="admin" ?<SideBar />: <CourseSidebar />}
          {/* Page Wrapper */}
          <div className="page-wrapper">
            <div className="content container-fluid">
              {/* Blog List */}
              <div className="row">
                <div className="col-md-9">
                  {/* <ul className="list-links mb-4">
                    <li className="active">
                      <Link to="/blog">Active Courses</Link>
                    </li>
                    <li>
                      <Link to="/pendingblog">Pending Courses</Link>
                    </li>
                  </ul> */}
                </div>
                <div className="col-md-3 text-md-end">
                  <Link
                    to="/addcourse"
                    className="btn btn-primary btn-blog mb-3"
                  >
                    <i className="feather-plus-circle me-1 ">
                      <FeatherIcon icon="plus-circle" className="blog-add" />
                      Add New
                    </i>
                  </Link>
                </div>
              </div>
              <Col md={6} lg={4} className="mb-4">
            </Col>
              <div className="row">
                {/* Blog Post */}
                {!loading.active && !courseDocs && <p>Error Fetching Courses</p>}
                {loading.active ? (
                        <Skeleton active paragraph={{ rows: 10 }} />
                      ) :
                      <>
                       {courseDocs &&
                  courseDocs.map(({ id, title, description, imageUrl }) => (
                    <div className="col-md-6 col-xl-4 col-sm-12 d-flex" key={id}>
                      <div className="blog grid-blog flex-fill ">
                        <div className="blog-image">
                          <Link to={"#"} onClick={() => storeCourseAction({id, action:"view"})} >
                            <img
                              className="img-fluid"
                              src={imageUrl[0] || blog6}
                              alt="Post Image"
                            />
                          </Link>
                        </div>
                        <div className="blog-content">
                          <ul className="entry-meta meta-item">
                            <li>
                              <div className="post-author">
                                <Link to="#" onClick={() => storeCourseAction({id, action:"view"})}>
                                  <img src={imageUrl[0] || avatar01} alt="Post Author" />
                                  <span>
                                    <span className="post-title">{title}</span>
                                  </span>
                                </Link>
                              </div>
                            </li>
                          </ul>
                          {/* <h3 className="blog-title">
                            <Link to="/coursedetails">{description}</Link>
                          </h3> */}
                          <p>
                            {description}
                          </p>
                        </div>
                        <div className="row">
                        {role==="admin" && <div className="edit-options">
                            <div className="edit-delete-btn fetrash">
                              <Link
                                to={`#`}
                                className="text-success"
                                onClick={() => storeCourseAction({id, action:"edit"})}
                              >
                                Edit
                              </Link>
                              <Link
                                to="#"
                                className="text-danger"
                                data-bs-toggle="modal"
                                data-bs-target="#deleteModal"
                                onClick={() => storeCourseAction({id, action:"delete"})}
                              >
                                Delete
                              </Link>
                            </div>
                            {/* <div className="text-end inactive-style">
                              <Link
                                to="#"
                                className="text-danger"
                                data-bs-toggle="modal"
                                data-bs-target="#deleteNotConfirmModal"
                              >
                                <i className="feather-eye-off me-1">
                                  <FeatherIcon icon="eye-off" />
                                  Inactive
                                </i>
                              </Link>
                            </div> */}
                          </div>}
                        </div>
                      </div>
                    </div>
                  ))}
                      </>}
               
                {/* /Blog Post */}
                {/* Blog Post */}
                {/* <div className="col-md-6 col-xl-4 col-sm-12 d-flex">
                  <div className="blog grid-blog flex-fill">
                    <div className="blog-image">
                      <Link to="/coursedetails">
                        <img
                          className="img-fluid"
                          src={blog2}
                          alt="Post Image"
                        />
                      </Link>
                      <div className="blog-views">
                        <i className="feather-eye me-1 blog-eye">
                          <FeatherIcon icon="eye" />
                          225
                        </i>
                      </div>
                    </div>
                    <div className="blog-content">
                      <ul className="entry-meta meta-item">
                        <li>
                          <div className="post-author">
                            <Link to="/profile">
                              <img src={avatar02} alt="Post Author" />
                              <span>
                                <span className="post-title">Lois A</span>
                                <span className="post-date">
                                  <i className="far fa-clock" /> 4 Dec 2022
                                </span>
                              </span>
                            </Link>
                          </div>
                        </li>
                      </ul>
                      <h3 className="blog-title">
                        <Link to="/coursedetails">
                          Learning is an objective, Lorem Ipsum is not
                        </Link>
                      </h3>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur em adipiscing
                        elit, sed do eiusmod tempor.
                      </p>
                    </div>
                    <div className="row">
                      <div className="edit-options">
                        <div className="edit-delete-btn fetrash">
                          <Link to="/editcourse" className="text-success">
                            <i className="feather-edit-3 me-1">
                              <FeatherIcon
                                icon="edit-3"
                                className="blog-edit"
                              />
                              Edit
                            </i>
                          </Link>
                          <Link
                            to="#"
                            className="text-danger"
                            data-bs-toggle="modal"
                            data-bs-target="#deleteModal"
                          >
                            <i className="feather-trash-2 me-1">
                              <FeatherIcon
                                icon="trash-2"
                                className="blog-trash"
                              />
                              Delete
                            </i>
                          </Link>
                        </div>
                        <div className="text-end inactive-style">
                          <Link
                            to="#"
                            className="text-danger"
                            data-bs-toggle="modal"
                            data-bs-target="#deleteNotConfirmModal"
                          >
                            <i className="feather-eye-off me-1">
                              <FeatherIcon icon="eye-off" />
                              Inactive
                            </i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* /Blog Post */}
              </div>
              {/* Pagination */}
              <div className="row ">
                <div className="col-md-12">
                  <div className="pagination-tab  d-flex justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item disabled">
                        <Link className="page-link" to="/course" tabIndex={-1}>
                          <i className="feather-chevron-left mr-2" />
                          Previous
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link className="page-link" to="/course">
                          1
                        </Link>
                      </li>
                      <li className="page-item active">
                        <Link className="page-link" to="#">
                          2 <span className="sr-only">(current)</span>
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link className="page-link" to="/course">
                          3
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link className="page-link" to="/course">
                          4
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link className="page-link" to="/course">
                          Next
                          <i className="feather-chevron-right ml-2" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Pagination */}
              {/* Modal */}
              <div
                className="modal fade contentmodal"
                id="deleteModal"
                tabIndex={-1}
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content doctor-profile">
                    <div className="modal-header pb-0 border-bottom-0  justify-content-end">
                      <button
                        type="button"
                        className="close-btn"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        <i className="feather-x-circle" />
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="delete-wrap text-center">
                        <div className="del-icon">
                          <i className="feather-x-circle" />
                        </div>
                        <h2>Sure you want to delete</h2>
                        <div className="submit-section">
                          <button className="btn btn-success me-2" onClick={() => deleteCourseById()}>
                            Yes
                          </button>
                          <Link
                            to="#"
                            className="btn btn-danger"
                            data-bs-dismiss="modal"
                          >
                            No
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Modal */}
            </div>
          </div>
          {/* /Page Wrapper */}
        </div>
        {/* /Main Wrapper */}
        {/* jQuery */}
        {/* Bootstrap Core JS */}
        {/* Feather Icon JS */}
        {/* Slimscroll JS */}
        {/* Select JS*/}
        {/* Feathericon js */}
        {/* Custom JS */}
      </>
    </div>
  );
};

export default (props) => <CourseView {...hooks.course(props)} />;